module.exports = __webpack_public_path__ + "images/fb60000e0b19ce262d12f1795f70f3f7.png";